export const ADDRESS_PANEL = '0';
export const PHONE_PANEL = '1';
export const FREQUENCY_PANEL = '2';
export const SLOT_PANEL = '3';
export const PAYMENT_PANEL = '4';
export const FINAL = '5';

export const OR_REGISTRATION_TOGGLE_PANEL = 'OR_REGISTRATION_TOGGLE_PANEL';

export function togglePanel(panelKey) {
  return {
    type: OR_REGISTRATION_TOGGLE_PANEL,
    panelKey,
  };
}

